module.exports = __webpack_public_path__ + "assets/process1.7aca0482.svg";